import { render, staticRenderFns } from "./Extrato.vue?vue&type=template&id=fd909e04"
import script from "./Extrato.vue?vue&type=script&lang=ts"
export * from "./Extrato.vue?vue&type=script&lang=ts"
import style0 from "./Extrato.vue?vue&type=style&index=0&id=fd909e04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports